import { defineStore } from 'pinia';
import { useModal } from '@composables/useModal.ts';
import { type SelectionItem } from '@models/selectionItem.ts';
import { ref } from 'vue';

export const useSelectionItemCommentsStore = defineStore('selection-item-comments-store', () => {
  const { isOpen, openModal, closeModal } = useModal();

  const currentSelectionItem = ref<SelectionItem | null>(null);
  const openCommentsModal = (selectionItem: SelectionItem) => {
    currentSelectionItem.value = selectionItem;
    openModal();
  };

  return {
    isOpen,
    closeModal,
    openCommentsModal,
    currentSelectionItem,
  };
});
